var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"g-divider",class:_vm.vertical ? 'vertical' : 'horizontal'})
}
var staticRenderFns = []

export { render, staticRenderFns }